<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Ranks List</h2> <router-link class="btn btn-secondary btn-sm" :to="{name:'ranks.create'}">Create New</router-link> 
            </div>
        </div>

        <div class="row justify-content-center mt-4">
            <table class="table table-hover">
                <thead>
                    <tr><th scope="col">#</th> <th scope="col">Rank</th> <th scope="col">Actions</th></tr>
                </thead> 
                <tbody>
                    <tr v-for="rank in ranks" :key="rank.id">
                        <th scope="row">{{rank.id}}</th> 
                        <td>{{rank.name}}</td> 
                        <td>
                            <div class="btn-group">
                                <router-link :to="{name: 'ranks.edit', params:{id: rank.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Edit'">
                                    <img src="../../../assets/svgs/Edit-Icon.svg">
                                </router-link>
                                <router-link v-if="currentUser.can('delete-ranks')" :to="{name: 'ranks.delete', params: {id: rank.id}}" class="btn btn-default py-0 px-1"  v-tooltip="'Delete'">
                                    <img src="../../../assets/svgs/Delete-Icon.svg">
                                </router-link>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import CurrentUser from '../../../mixins/CurrentUser';

export default {
    mixins: [CurrentUser],

    mounted() {
        this.$store.dispatch('ranks/fetch');
    },

    computed: {
        ranks: function () {
            return this.$store.state.ranks.data;
        }
    }
}
</script>